import { render, staticRenderFns } from "./pic-list.vue?vue&type=template&id=46504b1e&scoped=true&"
import script from "./pic-list.vue?vue&type=script&lang=js&"
export * from "./pic-list.vue?vue&type=script&lang=js&"
import style0 from "./pic-list.vue?vue&type=style&index=0&id=46504b1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46504b1e",
  null
  
)

component.options.__file = "pic-list.vue"
export default component.exports